// Module
var code = `<div class="{{.styleClassed}}" {{^.enabled}} disabled="" {{/}}>
    {{#if .placeholder}}
    <div class="title_placeholder" {{^.visibleTitlePlaceholder}}style="display:none" {{/}}>{{.placeholder}}:</div>
    {{/if}}
    <input class="investing_input_container_input_text" type={{.inputType}}
        placeholder="{{.placeholder}}" value="{{.text}}" as-tooltip="tooltip"
        on-focus="focus"
        on-blur="blur"
        on-keydown="keyDown"
        on-keyup="keyUp"
        on-wheel="mouseWheel" 
        on-mousewheel="mouseWheel"
        {{#.autofocus}} autofocus {{/}}
        {{#.isReadOnly}} readonly {{/}}
        autocomplete="off" />
</div>`;
// Exports
export default code;